/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Modal, Form, TableProps } from 'antd';
import { FlexBoxCenter } from 'styles';

import { TEvidenceCashReceiptDetail } from '../schema';

const AntdModal = styled(Modal)`
  .ant-modal-body {
    padding: 8px 24px 16px;
    .ant-form-item {
      margin: 0px;

      .ant-form-item-label label {
        font-weight: 400;
        color: #212529;

        &:after {
          display: none;
        }
      }
      .ant-col.ant-form-item-control {
        text-align: right;
        .ant-form-item-control-input {
          min-height: auto;
        }
      }
    }
  }

  .field-title,
  .field-title .ant-col.ant-form-item-label label {
    font-size: 18px;
    font-weight: 700;
  }
  .field-title,
  .field-title.ant-form-item {
    padding-bottom: 4px;
    margin: 8px 0px 12px;
    font-weight: 700;
    border-bottom: 1px solid #dcdcdc;
  }
`;

interface SalesByCompanyModalProps {
  open: boolean;
  evidenceData?: TEvidenceCashReceiptDetail;
  onCancel?: () => void;
}

const EvidenceCashReceiptModal = ({ open, evidenceData, onCancel }: SalesByCompanyModalProps) => {
  return (
    <AntdModal
      title="증빙 상세"
      width={400}
      open={open}
      onCancel={onCancel}
      okButtonProps={{ style: { display: 'none' } }}
      cancelText="닫기"
    >
      <Form>
        <div className="field-title">현금영수증</div>
        <div>
          <Form.Item label="용도구분">{evidenceData?.purposeTypeName}</Form.Item>
          <Form.Item label="거래구분">{evidenceData?.transactionTypeName}</Form.Item>
          <Form.Item label="발급수단번호">{evidenceData?.issuedByNumber}</Form.Item>
          <Form.Item label="작성일자">
            {evidenceData?.writeDate && moment(evidenceData?.writeDate).format('YYYY-MM-DD')}
          </Form.Item>
          <Form.Item label="승인번호">{evidenceData?.confirmNumber || '-'}</Form.Item>
        </div>
        <Form.Item label="총액" className="field-title">
          {evidenceData?.totalAmount?.toLocaleString()}
        </Form.Item>
        <div>
          <Form.Item label="공급가액">{evidenceData?.supplyAmount?.toLocaleString()}</Form.Item>
          <Form.Item label="세액">{evidenceData?.vatAmount?.toLocaleString()}</Form.Item>
        </div>
        <div className="field-title">공급자</div>
        <div>
          <Form.Item label="상호(법인)명">{evidenceData?.merchantName}</Form.Item>
          <Form.Item label="사업자 등록번호">{evidenceData?.merchantBizNumber}</Form.Item>
        </div>
      </Form>
    </AntdModal>
  );
};

export default EvidenceCashReceiptModal;
